var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconBackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 23.5L5.3 12.8c-.5-.5-.5-1.2 0-1.6L16.1.5c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.4L9.3 12l9.3 9.1c.7.7.7 1.7 0 2.4s-1.8.7-2.5 0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
}

export default SvgIconBackWhite;